import React, {FC, ReactElement, useEffect, useState} from 'react';
import styled from 'styled-components';
import { environment } from '../../../environments/environment';

type dividerProps = {
    borderWidth:string|null,
    borderColor:string|null,
    anchorName:string,
    anchorTrigger: string,
    editorPlugins: Record<string, any>
}

type dividerElementProps = {
    borderWidth:string|null,
    borderColor:string|null,
}

const DividerWrapper = styled.div`
position: relative;
    .resize-controls {
        button:not(.height) {
            display: none;
        }
    }
`

const DividerElement = styled.div<dividerElementProps>`
&.divider {
     ${props => props.borderWidth && `
        height: ${props.borderWidth}px;
        background-color: ${props.borderColor || '#000'};
    `};
}
`;

const Divider: FC<dividerProps> = ({...props}): ReactElement => {
    const [ size, setSize ] = useState<number>(Number(props.borderWidth));
    const emitSize = (borderWidth: number): void => setSize(borderWidth);
    const ResizeAxis = props.editorPlugins?.ResizeAxis;

    useEffect(() => setSize(Number(props.borderWidth)), [props.borderWidth])
    return (
        <DividerWrapper>
            {
                ResizeAxis && <ResizeAxis
                    heightProps={{ height: size, property: 'borderWidth', min: 1, max: 20, containerHeight: Number(props.borderWidth), emitHeight: emitSize }}
                    widthProps={{ width: '100', property: "", min: 0, max: 0, elementDomWidth: 0, containerWidth: 0, emitWidth: () => { } }}
                />
            }
            <DividerElement className={"divider"} borderWidth={String(size)} borderColor={props.borderColor}></DividerElement>
        </DividerWrapper>
    )
}


const environmentLink: string = environment().assetsLink;
export const settings:any = [
        [//group
            {
                settingName: 'BorderColor',
            },
            {
                settingName: 'BorderWidth',
                controls: [
                    {
                        controlName: 'InputNumber',
                        property: 'borderWidth',
                        title: 'Border size',
                        defaultValue: 0,
                        min:1,
                        max:20
                    },
                ],
            },
            {
                settingName: 'Anchor',
            }
        ],
    ];

const options = [
    {
        name:'borderColor',
        title: 'Color',
        icon: environmentLink + '/assets/images/Options/color.svg',
        action: 'setActiveSetting',
        settingTitle: 'Border Color'
    }
]
export default {
    Divider: Divider,
    settings,
    options,
    label: 'Divider'
};



